import { Button } from "@/components/ui/Button";
import { ApiError } from "@/api/client";

interface Props {
  query: {
    isError: boolean;
    isFetching: boolean;
    dataUpdatedAt: number;
    error: Error | null;
    refetch: () => Promise<unknown>;
  };
}

export function TaskSyncStatus({ query }: Props) {
  // Spec 021: fresh data needs no plate — lists refresh by themselves. Only a
  // failure (or the first load) says something.
  if (!query.isError && query.dataUpdatedAt > 0) return null;
  const expired = query.error instanceof ApiError && query.error.status === 401;
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-card border border-sep p-3">
      <p className="min-w-0 flex-1 text-meta text-text" role={query.isError ? "alert" : undefined}>
        {query.isError
          ? expired
            ? "Сессия истекла. Открой приложение заново, чтобы войти."
            : "Нет свежих данных. Исполнитель и статус задачи могли измениться."
          : query.dataUpdatedAt > 0
            ? `Обновлено ${new Date(query.dataUpdatedAt).toLocaleTimeString("ru-RU")}`
            : "Загружаем задачи…"}
      </p>
      <Button size="compact" variant="secondary" loading={query.isFetching}
        loadingText="Обновляем…" onClick={() => void query.refetch()}>
        {query.isError ? "Повторить" : "Обновить"}
      </Button>
    </div>
  );
}
